/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import {
  certReady,
  getCertResult,
  getFinancesCertList,
} from "../../apis/finances/cert";
import Modal from "../Modal";
//import { isEmpty } from "lodash-es";
import { getCertType } from "../../utils/cert";
import { classnames } from "../../utils/text";
import { viewLoading } from "../../utils/loading";
import Input from "../Input";

const TaxAccountantFinancesNationalPensionCert = (props) => {
  const {
    isShow, // 화면 oepn (프로그램 설치가 안된경우 open 안됨)
    toggle, // 열고 닫기 isShow의 toggle 함수
    submit, // 성공시 callback 함수
  } = props;

  const [financeCertList, setFinanceCertList] = useState([]);
  const [selectedCert, setSelectedCert] = useState(null);
  const [password, setPassword] = useState("");
  const [isHidePassword, setIsHidePassword] = useState(true);

  const [certInfo, setCertInfo] = useState({
    // userId: "",
    // userPw: "",
    agentId: "",
    agentPw: "",
  });

  const handleOnChangeId = (e) => {
    const { name, value } = e.target;
    setCertInfo({
      ...certInfo,
      [name]: value,
    });
  };

  const changePassword = (e) => {
    setPassword(e.target.value);
  };

  const reset = () => {
    setFinanceCertList([]);
    setPassword("");
    setSelectedCert(null);
  };
  const close = () => {
    toggle(false);
    setTimeout(() => {
      reset();
    }, 500);
  };

  const _submit = async () => {
    const {
      agentId,
    } = certInfo
    // if (!selectedCert) {
    //   systemAlert("인증서를 선택해주세요.");
    //   return false;
    // }
    // if (!password) {
    //   systemAlert("패드워드를 입력해주세요.");
    //   return false;
    // }
    // if (!userId || !userPw) {
    //   systemAlert("사용자 로그인정보를 입력해주세요.");
    //   return false;
    // }
    // if (!agentId || !agentPw) {
    //   systemAlert("세무대리인정보를 입력해주세요.");
    //   return false;
    // }
    const params = {
      signPw: password,
      orgCd: "common",
      svcCd: "getCertInfo",
      appCd: "InfotechApiDemo",
      signCert: selectedCert?.path + "\\signCert.der",
      signPri: selectedCert?.path + "\\signPri.key",
    };
    viewLoading(true);
    try {
      const certResult = await getCertResult(params);
      submit({
        password,
        agentId,
        ...certResult,
        ...selectedCert,
      });
      close();
    } catch (error) { }
    viewLoading(false);
  };

  const selectCert = (cert) => {
    setSelectedCert(cert);
  };

  const _getFinancesCertList = useCallback(async () => {
    setFinanceCertList([]);
    try {
      await certReady();
      viewLoading(true);
      const list = await getFinancesCertList();
      viewLoading(false);
      setFinanceCertList(list);
    } catch (error) {
      close();
      return;
    }
  }, []);

  useEffect(() => {
    if (isShow) {
      _getFinancesCertList();
    }
  }, [isShow]);

  return (
    <>
      <Modal isOpen={isShow} size="md"> {/**<Modal isOpen={!isEmpty(financeCertList)} size="md"> */}
        <form>
          <div className="finances-cert-popup pop-layer">
            <div className="pop-container">
              <div
                style={{
                  float: "left",
                  fontSize: "1.8em",
                  fontWeight: "bold",
                  color: "teal",
                }}
              >
                공인인증 전자서명
              </div>

              <div style={{ height: "80px" }}></div>
              <div
                style={{
                  fontSize: "1.6em",
                  fontWeight: "bold",
                  marginBottom: "16px",
                }}
              >
                인증서 선택
              </div>

              <div>
                <div
                  style={{
                    width: "520px",
                    overflowX: "scroll",
                    overflowY: "scroll",
                  }}
                >
                  <table
                    style={{
                      width: "auto",
                      border: "0px",
                      tableLayout: "fixed",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            width: "50px",
                            border: "1px solid rgba(128, 128, 128, 0.2)",
                          }}
                        >
                          {" "}
                          구분
                        </th>
                        <th
                          style={{
                            width: "230px",
                            border: "1px solid rgba(128, 128, 128, 0.2)",
                          }}
                        >
                          {" "}
                          인증서명
                        </th>
                        <th
                          style={{
                            width: "100px",
                            border: "1px solid rgba(128, 128, 128, 0.2)",
                          }}
                        >
                          {" "}
                          만료일
                        </th>
                        <th
                          style={{
                            width: "100px",
                            border: "1px solid rgba(128, 128, 128, 0.2)",
                          }}
                        >
                          {" "}
                          발급자
                        </th>
                        <th
                          style={{
                            width: "300px",
                            border: "1px solid rgba(128, 128, 128, 0.2)",
                          }}
                        >
                          {" "}
                          위치
                        </th>
                      </tr>
                    </thead>
                    <tbody id="tbody" style={{ textAlign: "center" }}>
                      {financeCertList.map((data, idx) => (
                        <tr
                          onClick={() => selectCert(data)}
                          key={idx}
                          className={classnames({
                            selected:
                              selectedCert &&
                              selectedCert.certName === data.certName,
                          })}
                        >
                          <td style={{
                            whiteSpace: 'nowrap',
                            padding: '0 10px',
                          }}>
                            {getCertType(data.oid)}
                          </td>
                          <td
                            style={{ width: "230px", textOverflow: "ellipsis", padding: '0 10px' }}
                          >
                            {data.certName}
                          </td>
                          <td style={{
                            width: "100px",
                            whiteSpace: 'nowrap',
                            padding: '0 10px',
                          }}>{data.toDt}</td>
                          <td style={{ width: "100px", padding: '0 10px' }}>{data.pub}</td>
                          <td style={{ width: "auto" }}>{data.path}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "1.6em",
                    fontWeight: "bold",
                    marginBottom: "5px",
                    borderBottom: "1px solid #DDD",
                    marginTop: "30px",
                    lineHeight: "1.8em",
                  }}
                >
                  인증서 암호입력
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <input
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        _submit();
                        return false;
                      }
                    }}
                    onChange={changePassword}
                    type="password"
                    style={{
                      width: "500px",
                      height: "30px",
                      marginTop: "10px",
                    }}
                  />
                  <div style={{ fontSize: "1.1.5em", marginTop: "10px" }}>
                    안전한 개인정보 관리를 위해 6개월마다 비밀번호를 변경하기
                    바랍니다.
                  </div>
                </div>
              </div>
              {/* 세무사 로그인 정보 추가 */}

              <div className="bank-account-connect-page">
                <div className="second-step-container">
                  <div
                    className="cert-id-login-container"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <div style={{ width: '100%' }}>
                      <h4 className="mb-10 ml-5">대리인 정보 <span className="color-red-100">(대리인 사업장 관리번호 입력)</span></h4>
                      <form
                        className="cert-id-login-form"
                        style={{ width: '100%', marginLeft: 0 }}
                      >
                        <div className="input-wrap id">
                          <label className="input-label" style={{ width: '70px' }}>관리번호</label>
                          <Input
                            style={{ padding: '15px 0' }}
                            className="id-input"
                            name="agentId"
                            value={certInfo.agentId}
                            onChange={handleOnChangeId}
                            placeholder="관리번호를 입력해주세요"
                          />
                        </div>
                      </form>
                    </div>
                    {/* <div style={{ width: '48%', marginLeft: 'auto' }}>
                      <h4 className="mb-10 ml-5">사용자</h4>
                      <form
                        className="cert-id-login-form"
                        style={{ width: '100%', marginLeft: 0 }}
                      >
                        <div className="input-wrap id">
                          <label className="input-label" style={{ width: '70px' }}>아이디</label>
                          <Input
                            style={{ padding: '15px 0' }}
                            className="id-input"
                            name="userId"
                            value={certInfo.userId}
                            onChange={handleOnChangeId}
                            placeholder="아이디를 입력해주세요"
                          />
                        </div>
                        <div className="input-wrap password">
                          <label className="input-label" style={{ width: '70px' }}>패스워드</label>
                          <Input
                            style={{ padding: '15px 0' }}
                            className="password-input"
                            name="userPw"
                            type={isHidePassword ? "password" : "text"}
                            value={certInfo.userPw}
                            onChange={handleOnChangeId}
                            autoComplete="off"
                            placeholder="패스워드를 입력해주세요"
                          />
                          <span className="icon">
                            <i
                              className={`mdi ${isHidePassword ? "mdi-eye" : "mdi-eye-off"
                                } font-size-24`}
                              onClick={() => setIsHidePassword(!isHidePassword)}
                            />
                          </span>
                        </div>
                      </form>
                    </div> */}
                  </div>
                </div>
              </div>
              {/* 세무사 로그인 정보 추가 */}

              <div
                className="pop-conts"
                style={{ marginTop: "30px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <a
                    onClick={close}
                    className="btn-default btn-layerClose"
                    style={{ marginRight: "20px" }}
                    id="certCancel"
                  >
                    취소
                  </a>
                  <a
                    onClick={_submit}
                    className="btn-success btn-layerConfirm"
                    id="certConfirm"
                  >
                    확인
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default TaxAccountantFinancesNationalPensionCert;
